<template>
  <footer class="mix-footer">
      <p>{{ mixologyData.FOOTER }}</p>
  </footer>
</template>

<script>
import mixologyData from "./../../../static/libs/mixology"
export default {
    name: "mix-footer",
    data() {
        return {
            mixologyData

        }
    }
}
</script>

<style lang="scss">
@import "./../../variables.scss";
.mix-footer{
    background-color: $bubly-blue;
    box-sizing: border-box;
    padding: 30px 15px;
    width: 100%;
    p {
        font-size: 10px;
        margin: 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/mixology/MixFooter.vue